import { Directive, Input, OnChanges, OnInit } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[disableControl]'
})
export class DisableControlDirective implements OnChanges {
  disabled: boolean = false;
  
  @Input() set disableControl(condition: boolean) {
    if (this.disabled !== undefined) {
      this.toggleControl(condition);
    }
    this.disabled = condition;
  }

  constructor(private ngControl: NgControl) {}

  ngOnChanges() {
    this.toggleControl(this.disabled);
  }

  toggleControl(condition: boolean) {
    const action = condition ? 'disable' : 'enable';
    this.ngControl.control?.[action]();
  }
}